export enum OrderStatus {
    Created = 'CREATED',
    Processing = 'PROCESSING',
    Completed = 'COMPLETED',
    Rejected = 'REJECTED'
}
